window.themeAPI = window.themeAPI || {};

// 调试日志辅助函数（仅在开发环境输出）
// 使用 window.DEBUG 避免与其他文件冲突
if (typeof window.DEBUG === 'undefined') {
  window.DEBUG = window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1');
}

function debugLog(...args) {
  if (window.DEBUG) console.log(...args);
}
function debugWarn(...args) {
  if (window.DEBUG) console.warn(...args);
}
function debugError(...args) {
  if (window.DEBUG) console.error(...args);
}

themeAPI.cacheSelectors = function () {
  themeAPI.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $variantImage: $('#VariantImage'),
    $productImageGallery: $('.gallery__item'),

    // Add to cart - Ajax
    $cartBuggle: $('.cart-count-bubble'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

themeAPI.init = function () {
  themeAPI.cacheSelectors();
  timber.cacheVariables();
  themeAPI.productImageGallery();
  themeAPI.enableAjax();
};

themeAPI.productImageGallery = function() {
  if (!themeAPI.cache.$productImageGallery.length) {
    return;
  };

  themeAPI.cache.$productImage.on('click', function() {
    const mediaType = $(this).data('media-type');
    console.log(mediaType)
    if (mediaType == 'image') {
      var imageId = $(this).attr('data-image-id');
      themeAPI.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
    }
  });

  themeAPI.cache.$variantImage.on('click', function() {
    var imageId = $(this).attr('data-image-id');
    themeAPI.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });

  if(window.innerWidth >= 1024){
    themeAPI.cache.$productImageGallery.magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
      closeOnBgClick: true,
      closeBtnInside: false,
      closeOnContentClick: true,
      tClose: 'Close',
      removalDelay: 500,
      callbacks: {
        open: function(){
          $('html').css('overflow-y','hidden');
        },
        close: function(){
          $('html').css('overflow-y','');
        }
      },
      titleSrc: 'title',
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
        tPrev: 'Prev',
        tNext: 'Next'
      }
    });
  }
};

themeAPI.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

themeAPI.renderCartDrawerItem = function (item) {
  // console.log(item)
  if (item.id) {
    $('.drawer__inner-empty').hide();
    $('.drawer__footer').removeClass('hidden');
    $('.drawer').removeClass('is-empty');
    $('cart-drawer-items').removeClass('is-empty');
  }

  let  customData = {}, 
  drawer__itemImage = '', 
  drawer__itemOptions = '',
  drawer__itemDiscount = '',
  drawer__itemPrice = '';

  if (item.properties && item.properties._customorderid) {
    customData.orderid = item.properties._customorderid;
    customData.trozosurl = item.url.split('?')[0];
    customData.orderkey = item.properties._customorderkey;
    customData.imagefront = item.properties._customimagefront;
    customData.imageback = item.properties._customimageback;
    customData.auth = item.properties._customauth;

    drawer__itemImage = `<a href="${customData.trozosurl}?id=${customData.orderid}&key=${customData.orderkey}&imf=${customData.imagefront}&imb=${customData.imageback}&auth=${customData.auth}"
      class="cart__image block">
      <img src="//s3.amazonaws.com/qsmzorderimages/${customData.imagefront}"
        style="width: 150px" alt="${item.title}">
    </a>`;
  }else{
    let webp_flag = item.image.includes('.webp') ? true : false;
    let imageArr,itemImage; 
    if(webp_flag){
      imageArr = item.image.split('.webp');
      itemImage = imageArr[0] + '_medium.webp' + imageArr[1];
    }else{
      imageArr = item.image.split('.png');
      itemImage = imageArr[0] + '_medium.png' + imageArr[1];
    }
    drawer__itemImage = `<a href="${item.url}" class="cart__image block">
      <img src="${itemImage}" alt="${item.title}">
    </a>`;
  }

  if (!item.product_has_only_default_variant) {
    for (let i = 0; i < item.options_with_values.length; i++) {
      const option = item.options_with_values[i];
      let optionValue = option.value;
      if (item.handle.includes('-phone-cases') && option.name == 'Color' ) {
        optionValue = option.value.split(' | ')[1];
      }
      drawer__itemOptions += `<span class="block">${optionValue}</span>`;
    }
  }

  var drawer__itemTitle = item.product_title;
  if (item.handle.includes('-phone-cases')) {
    drawer__itemTitle = item.variant_options[1].split(' | ')[0];
  }

  const original_line_price = parseFloat(item.original_line_price);
  const final_line_price = parseFloat(item.final_line_price);
  if (original_line_price != final_line_price) {
    const original_price = Shopify.formatMoney(item.original_line_price, "");
    drawer__itemPrice = `<s class="cart-item__old-price">
      <span class="money">${original_price}</span>
    </s>`;
  }
  const current_price = Shopify.formatMoney(item.final_line_price, "");
  drawer__itemPrice += `<span class="money">${current_price}</span>`;

  if (original_line_price != final_line_price && item.line_level_discount_allocations.length > 0) {
    for (let i = 0; i < item.line_level_discount_allocations.length; i++) {
      const discount_item = item.line_level_discount_allocations[i].discount_application;
      drawer__itemDiscount += `<small class="cart-item__discount ml-1 text-size-12">
        ${discount_item.title}
      </small>`;
    }
  }

  let minusInput = '<input type="button" class="on-quantity" value="-" data-v="-1">', 
    plusInput= '<input type="button" class="on-quantity" value="+" data-v="1">',
    quantifyMax = 999,
    quantityOverHintDisplay = 'hidden',
    currentVariant = {};

  $.getJSON(`/products/${item.handle}.js`, function(product) {
    // console.log(item);
    let product_variants = product.variants;
    for (let i = 0; i < product_variants.length; i++) {
      const variant_id = product_variants[i].id;
      if (item.id == variant_id) {
        currentVariant = product_variants[i];
        if (item.quantity == 1) {
          minusInput = `<input type="button" class="on-quantity" value="-" data-v="-1" disabled>`;
        }

        if (item.quantity == currentVariant.inventory_quantity) {
          plusInput = `<input type="button" class="on-quantity" value="+" data-v="1" disabled>`;
        }

        if (currentVariant.inventory_policy == 'deny') {
          quantifyMax = currentVariant.inventory_quantity;
        }

        if (currentVariant.inventory_management && item.quantity >= currentVariant.inventory_quantity && currentVariant.inventory_policy == 'deny' ) {
          quantityOverHintDisplay = '';
        }
        break;
      }
    }
  });

  let sticker_notice = '', notice_text = '';
  const item_handle = item.handle;
  console.log(item_handle)
  if (item_handle.includes('random-gift-for-order-paid-over')) {
    notice_text = `Note: We gift only <b>one</b> item if your order is paid over a certain amount as listed, otherwise, it won't be delivered.`;
    if (item_handle.includes('september-only')) {
      notice_text = `Note:We will send you <b>one</b> gift if your order includes any iPhone 16 case and the total order is paid over a certain amount; otherwise, the gift won't be delivered.`
    }
  }else {
    switch (item_handle) {
      case 'pitaka-gift-wrapping':
        notice_text = 'Note: Only for phone cases. (Ship from China)'
        break;
      case 'magsafe-sticker':
        notice_text = 'Note: The MagSafe Sticker is free when you purchase Air Case for iPhone 13 series. Otherwise, it won’t be delivered.'
        break;
      case 'lucky-box-for-usa':
        notice_text = `Important information:<br>
          1. Please note that we will prioritize shipping your preferred color, 
          but if it is out of stock, we will send a random color case to you.<br>
          2. If the cases you receive do not have any defects, we do not support refunds.`;
        break;
      case 'magez-grip-gift':
        notice_text = 'Important Notice: Item shipment requires a minimum order of $70. Orders below this amount will not be delivered. This offer expires on Dec 28th at 11:59 PM PST'
        break;
      case 'charging-cable-extended-version-2m':
        notice_text = 'Free Extended c-c cable for the first 300 orders only. iPhone 15 series pre-order now. Shipping will begin on September 13th.';
        break;
    }
  }
  if (notice_text != '') {
    sticker_notice = `<div class="w-full bg-black bg-opacity-5 border border-grey p-2 mb-2 text-size-12">
      ${notice_text}
    </div>`;
  }

  // const line_index = $('.drawer__cart-items-wrapper').find(".cart-item[id^='CartDrawer-Item-']").length + 1;
  const line_index = 1;
  const cartDrawerItemHTML = `<div id="CartDrawer-Item-${line_index}"
    class="cart-item flex flex-wrap relative border-b border-grey pt-6 pb-8"
    data-cart-item data-variant-id="${ item.id }" data-cart-item-id="${item.key}" aria-live="polite">
    ${sticker_notice}
    <div class="cart-item__media w-3/10 pr-3 relative">
      ${drawer__itemImage}
    </div>

    <div class="cart-item__details flex flex-col justify-between w-7/10">
      <div class="flex justify-between">
        <div class="space-y-px">
          <p class="cart-drawer__item-subtitle text-grey" data-cart-item-variant-title>
            ${drawer__itemOptions}
          </p>
          <a href="${item.url}" target="_blank" class="cart-item__name font-medium text-size-12 line-clamp-1"
            data-cart-item-href data-cart-item-title>
            ${ drawer__itemTitle }
          </a>

          <ul class="cart-drawer__item-properties" data-cart-item-property-list></ul>
        </div>
        <div class="cart-item__totals" data-cart-item-price-container>
          <div class="loading__spinner hidden">
            <svg
              aria-hidden="true"
              focusable="false"
              class="spinner"
              viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
          <div class="cart-item__price-wrapper text-size-14 font-medium">
            <div class="cart-item__discounted-prices">
              ${drawer__itemPrice}
            </div>
            ${drawer__itemDiscount}
          </div>
        </div>
      </div>
      <div class="cart-item__quantity">
        <div class="quantity-box">
          <quantity-popover>
            <div class="cart-item__quantity-wrapper quantity-popover-wrapper flex justify-between items-center">
              <div class="quantity-popover-container">
                <quantity-input class="quantity cart-quantity">
                  <button class="quantity__button" name="minus" type="button">
                    <span class="visually-hidden">Decrease quantity for ${item.product_title}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                      </path>
                    </svg>
                  </button>
                  <input class="quantity__input w-9 sm:w-12 lg:w-15 xl:w-16" type="number" data-quantity-variant-id="${item.id}" 
                    name="updates[]" value="${item.quantity}" data-cart-quantity="${item.quantity}" min="0" data-min="1" max="${quantifyMax}" step="1" 
                    aria-label="Quantity for ${item.product_title}" id="Drawer-quantity-${line_index}" data-index="${line_index}">
                  <button class="quantity__button" name="plus" type="button">
                    <span class="visually-hidden">Increase quantity for ${item.product_title}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                      </path>
                    </svg>
                  </button>
                </quantity-input>
              </div>
              <cart-remove-button id="CartDrawer-Remove-${line_index}" data-index="${line_index}">
                <button type="button" class="inline-block cart-remove-button" aria-label="Remove ${item.product_title}" data-variant-id="${item.id}">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                  </svg>
                </button>
              </cart-remove-button>
            </div>
          </quantity-popover>
        </div>
        <span class="quantity_over_hint static mt-2 sm:absolute sm:mt-0 sm:bottom-1 right-0 text-size-12 text-orange-500 ${quantityOverHintDisplay}">
          All ${currentVariant.inventory_quantity} ${currentVariant.title} are in your cart.
        </span>
      </div>
    </div>
  </div>`;

  $('.drawer__cart-items-wrapper>.cart-items').prepend(cartDrawerItemHTML);
  // let drawer_hasItem = false;
  // $('.drawer__cart-items-wrapper>.cart-items').find('.cart-item').each(function(){
  //   var $this = $(this);
  //   const itemId = $this.data('cart-item-id');
    
  //   if(item.key == itemId){
  //     drawer_hasItem = true;
  //     var currentQuantity = item.quantity;
  //     $this.find('input.quantity__input').val(currentQuantity);
  //     if (openDrawer) {
  //       document.querySelector('#cart-icon-bubble').click();
  //     }
  //     return false;
  //   }
  // })

  // if(!drawer_hasItem){
  //   $('.drawer__cart-items-wrapper>.cart-items').prepend(cartDrawerItemHTML);
  //   if (openDrawer) {
  //     document.querySelector('#cart-icon-bubble').click();
  //   }
  // }
}

themeAPI.addToCartflip = function ($addToCartBtn, openDrawer = true) {
  var addToCartText = $addToCartBtn.data('add-to-cart') || "Add to cart";
  $addToCartBtn
    .data('add-to-cart', addToCartText)
    .prop('disabled', false)
    .removeClass('disabled')
    .removeClass('btn--loading');

  // 使用 Section Rendering API 更新购物车抽屉
  fetch('/?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      // 如果购物车之前是空的，移除空状态
      if ($('#CartDrawer').find('.drawer__inner-empty').length > 0) {
        $('cart-clear-button').removeClass('hidden');
        $('.drawer__footer').removeClass('hidden');
        $('cart-drawer').removeClass('is-empty');
        $('cart-drawer-items').removeClass('is-empty');
        $('#CartDrawer').find('.drawer__inner-empty').remove();
        $('#CartDrawer-Checkout').prop('disabled', false);
      }

      // 更新购物车抽屉的各个部分
      const selectors = ['cart-drawer-items', '.cart-drawer__footer', 'cart-clear-button'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }

      // 打开购物车抽屉
      if (openDrawer) {
        setTimeout(function() {
          var cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon && typeof cartIcon.click === 'function') {
            try {
              cartIcon.click();
            } catch (error) {
              console.error('[addToCartflip] Failed to click cart icon:', error);
            }
          }
        }, 300);
      }
    })
    .catch((e) => {
      console.error('[addToCartflip] Failed to update cart drawer:', e);
      // 即使更新失败，也尝试打开抽屉
      if (openDrawer) {
        setTimeout(function() {
          var cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon) {
            cartIcon.click();
          }
        }, 300);
      }
    });
};
themeAPI.enableAjax = function () {
  themeAPI.cache.$body.on('click', 'form[action^="/cart/add"] :submit', function(e) {
    e.preventDefault();
    $('.note.errors').remove();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        .prop('disabled', true)
        .addClass('disabled')
        .addClass('btn--loading');

      // 使用 CartRequestManager 包装请求
      const addToCartRequest = window.CartRequestManager
        ? CartRequestManager.wrapAjax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: $addToCartForm.serialize()
          })
        : $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: $addToCartForm.serialize()
          });

      addToCartRequest
        .then(function(lineItem) {
          // console.log(lineItem)
          //Case 4 for i15: 7158297493574,7159469965382
          //Case Pro 4 for i15: 7158415622214
          //Case 3 for S23: 7088899522630
          //Case Pro 3 for i14: 7000172527686
          //Case 3 for i14: 7000151883846
          //Air Case for i13: 6676963459142,6715813265478,7015780515910
          //Air Case for S22: 6892080398406
          //const halloweenIds = [7000151883846,7000172527686,6802204295238,6699360124998,7010412822598,7015780515910,6715813265478,6715748974662,7020962021446,6903326801990,6821764923462,3981118308422,4693882699846,7026664079430,6906836648006,4835291103302,6707106971718,4463372369990,6821645156422,6801496965190,6679107600454,6937306267718,6935535910982,6988622397510]
          //const productIds_ss = [7088899522630,7000172527686,7000151883846,6676963459142,6715813265478,7015780515910];
          // const productIds = [6676963459142,6715813265478,7015780515910,6892080398406];
          // if(productIds.includes(lineItem.product_id)){
          //   var $freeGiftForm = $addToCartForm.prev('#gift_form');
          //   $.ajax({
          //     url: '/cart/add.js',
          //     dataType: 'json',
          //     type: 'post',
          //     data: $freeGiftForm.serialize(),
          //     success: function(freeItem) {
          //       // console.log(freeItem)
          //       themeAPI.addToCartflip($addToCartBtn, freeItem);
          //     }
          //   });
          // }
          // if(halloweenIds.includes(lineItem.product_id)){
          //   // console.log(lineItem)
          //   var $freeGripForm = $addToCartForm.prev('#grip_form');
          //   $.ajax({
          //     url: '/cart/add.js',
          //     dataType: 'json',
          //     type: 'post',
          //     data: $freeGripForm.serialize(),
          //     success: function(gripItem) {
          //       //console.log(gripItem)
          //       themeAPI.addToCartflip($addToCartBtn, gripItem);
          //     }
          //   });
          // }

          // 关闭模态框
          const data_autoClose = $addToCartForm.serializeArray().filter(item => item.name == 'cart_autoClose');
          if(data_autoClose.length > 0 && $('body>.grid-form-modal').length > 0 ){
            $('body>.grid-form-modal').hasClass('active') && $('body>.grid-form-modal').find('.form_btn-close').click();
          }

          // 使用 CartRequestManager 获取购物车信息
          const cartRequest = window.CartRequestManager
            ? CartRequestManager.getCart()
            : $.getJSON('/cart.js');

          cartRequest.then(function(cart) {
            themeAPI.cache.$cartBuggle.addClass("cart-link__bubble--visible");
            themeAPI.cache.$cartBuggle.text(cart.item_count);
            var totalPrice = Shopify.formatMoney(cart.total_price, "");
            $(".cart-drawer__subtotal-number").html(totalPrice);
          }).catch(function(error) {
            console.error('[Cart] Failed to get cart:', error);
          });

          $addToCartBtn.removeClass('btn--loading');
          themeAPI.addToCartflip($addToCartBtn);

          // 尝试添加礼品（如果存在）
          var $giftForm = $addToCartForm.prev('#gift_form');
          if ($giftForm.length > 0) {
            const giftRequest = window.CartRequestManager
              ? CartRequestManager.wrapAjax({
                  url: '/cart/add.js',
                  dataType: 'json',
                  type: 'post',
                  data: $giftForm.serialize()
                })
              : $.ajax({
                  url: '/cart/add.js',
                  dataType: 'json',
                  type: 'post',
                  data: $giftForm.serialize()
                });

            giftRequest.catch(function(error) {
              console.error('[Gift] Failed to add gift:', error);
            });
          }

        })
        .catch(function(error) {
          // 处理错误（兼容 Promise 和 jQuery）
          let response = 'Failed to add to cart';
          let status = 0;

          if (error.responseText) {
            // jQuery error
            try {
              var data = JSON.parse(error.responseText);
              response = data.description || response;
            } catch(e) {
              // 如果解析失败，使用默认消息
            }
            status = error.status;
          } else if (error.message) {
            // Promise error
            response = error.message;
          }

          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Sold out");
          }
          else {
            window.alert(response);
          }
          $addToCartBtn.prop('disabled', false).removeClass('disabled');
          $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          if($addToCartBtn.closest('form').siblings('.error-note').length > 0){
            $addToCartBtn.closest('form').siblings('.error-note').show();
          }else{
            $addToCartBtn.after('<p class="note errors text-size-12">' + response + '</p>');
          }
        });
    }
  });
};

// Initialize theme's JS on docready
$(themeAPI.init)

